var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TrackingPayPalTableAdmin',{attrs:{"filterGetParams":_vm.filterGetParams},on:{"filter":_vm.filter,"showMore":_vm.showMore,"resetFilter":_vm.resetFilter,"reload":_vm.reload,"changeFilter":_vm.changeFilter,"downloadFiles":_vm.downloadFiles}})
}
var staticRenderFns = []

export { render, staticRenderFns }